// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-5ffadc99]{cursor:pointer}.car-table .cell-title[data-v-5ffadc99]{font-size:1.7rem}.car-table .cell-info[data-v-5ffadc99]{font-size:1.3rem;white-space:pre;color:#9c9c9c}", ""]);
// Exports
module.exports = exports;
